(() => {
  const mobileMedia = window.matchMedia('(max-width: 749px)');
  let observer = null;

  const imageKey = (src) => {
    try {
      return new URL(src, window.location.origin).pathname;
    } catch (_) {
      return src || '';
    }
  };

  const sizedImageUrl = (src) => {
    try {
      const url = new URL(src, window.location.origin);
      url.searchParams.set('width', '720');
      return url.toString();
    } catch (_) {
      return src;
    }
  };

  const buildDots = (media, track) => {
    let dots = media.querySelector('.ed-product-card__gallery-dots');
    if (!dots) {
      dots = document.createElement('span');
      dots.className = 'ed-product-card__gallery-dots';
      dots.setAttribute('aria-hidden', 'true');
      media.appendChild(dots);
    }

    const slides = track.querySelectorAll('.ed-product-card__gallery-slide');
    dots.innerHTML = '';
    if (slides.length < 2) {
      dots.hidden = true;
      return dots;
    }

    dots.hidden = false;
    slides.forEach((_, index) => {
      const dot = document.createElement('i');
      dot.className = `ed-product-card__gallery-dot${index === 0 ? ' is-active' : ''}`;
      dots.appendChild(dot);
    });
    return dots;
  };

  const syncDots = (track, dots) => {
    if (!dots || dots.hidden) return;
    const width = track.clientWidth || 1;
    const index = Math.max(0, Math.min(dots.children.length - 1, Math.round(track.scrollLeft / width)));
    Array.from(dots.children).forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
  };

  const appendGalleryImages = (track, media, mediaLink, productData) => {
    if (!productData || !Array.isArray(productData.images)) return;
    const known = new Set(Array.from(track.querySelectorAll('img')).map((img) => imageKey(img.currentSrc || img.src)));
    const title = productData.title || mediaLink.getAttribute('aria-label') || '';

    productData.images.forEach((image) => {
      const src = typeof image === 'string' ? image : image?.src;
      if (!src || known.has(imageKey(src))) return;
      known.add(imageKey(src));

      const slide = document.createElement('span');
      slide.className = 'ed-product-card__gallery-slide';
      slide.setAttribute('data-card-gallery-slide', '');

      const img = document.createElement('img');
      img.className = 'ed-product-card__image ed-product-card__image--gallery-extra';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.alt = title;
      img.sizes = '50vw';
      img.src = sizedImageUrl(src);

      slide.appendChild(img);
      track.appendChild(slide);
    });

    const dots = buildDots(media, track);
    syncDots(track, dots);
  };

  const loadFullGallery = async (card, media, track, mediaLink) => {
    if (card.dataset.galleryLoaded === 'true' || track.children.length < 2) return;
    card.dataset.galleryLoaded = 'true';

    try {
      const productUrl = new URL(mediaLink.href, window.location.origin);
      productUrl.search = '';
      productUrl.hash = '';
      const response = await fetch(`${productUrl.pathname}.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      const productData = await response.json();
      appendGalleryImages(track, media, mediaLink, productData);
    } catch (_) {
      /* Keep the two-image swipe preview when product JSON is unavailable. */
    }
  };

  const initCard = (card) => {
    if (card.dataset.galleryInit === 'true') return;
    const mediaLink = card.querySelector('.ed-product-card__media-link');
    const media = mediaLink?.querySelector('.ed-product-card__media');
    if (!mediaLink || !media) return;

    const originalImages = Array.from(media.children).filter((node) => node.matches?.('img.ed-product-card__image'));
    if (!originalImages.length) return;

    card.dataset.galleryInit = 'true';
    const track = document.createElement('span');
    track.className = 'ed-product-card__gallery-track';
    track.setAttribute('data-card-gallery-track', '');

    originalImages.forEach((img, index) => {
      const slide = document.createElement('span');
      slide.className = 'ed-product-card__gallery-slide';
      slide.setAttribute('data-card-gallery-slide', '');
      if (index > 0) img.loading = 'lazy';
      slide.appendChild(img);
      track.appendChild(slide);
    });

    media.prepend(track);
    card.classList.add('is-card-gallery-ready');
    let dots = buildDots(media, track);

    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        syncDots(track, dots);
        ticking = false;
      });
    }, { passive: true });

    let startX = 0;
    let dragged = false;
    mediaLink.addEventListener('pointerdown', (event) => {
      startX = event.clientX;
      dragged = false;
    }, { passive: true });
    mediaLink.addEventListener('pointermove', (event) => {
      if (Math.abs(event.clientX - startX) > 8) dragged = true;
    }, { passive: true });
    mediaLink.addEventListener('click', (event) => {
      if (!dragged) return;
      event.preventDefault();
      event.stopPropagation();
      dragged = false;
    }, true);

    if (track.children.length > 1) {
      if (!observer) {
        observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const observedCard = entry.target;
            observer.unobserve(observedCard);
            const observedLink = observedCard.querySelector('.ed-product-card__media-link');
            const observedMedia = observedLink?.querySelector('.ed-product-card__media');
            const observedTrack = observedMedia?.querySelector('[data-card-gallery-track]');
            if (observedLink && observedMedia && observedTrack) {
              loadFullGallery(observedCard, observedMedia, observedTrack, observedLink).then(() => {
                dots = observedMedia.querySelector('.ed-product-card__gallery-dots');
              });
            }
          });
        }, { rootMargin: '320px 0px' });
      }
      observer.observe(card);
    }
  };

  const initMobileGalleries = () => {
    if (!mobileMedia.matches) return;
    document.querySelectorAll('.ed-product-card--collection').forEach(initCard);
  };

  initMobileGalleries();
  mobileMedia.addEventListener?.('change', initMobileGalleries);
})();
